export const GET_LINEUP = 'GET_LINEUP'
export const GET_LINEUP_SUCCESS = 'GET_LINEUP_SUCCESS'
export const GET_LINEUP_ERROR = 'GET_LINEUP_ERROR'

export const GET_NAV_LINEUP = 'GET_NAV_LINEUP'
export const GET_NAV_LINEUP_SUCCESS = 'GET_NAV_LINEUP_SUCCESS'
export const GET_NAV_LINEUP_ERROR = 'GET_NAV_LINEUP_ERROR'
